import { FC } from 'react';
import { ImageDto } from '../../../services/generatedApi';
import MediaViewImage from '../../ObjectPageComponents/ObjectHero/MediaViewImage';

type Props = {
  images: ImageDto[];
};

const ImageView: FC<Props> = ({ images }) => {
  return (
    <>
      {images &&
        images
          ?.filter((image) => image?.category.toLowerCase() !== 'planlösning')
          .map((image, index) => {
            return (
              <MediaViewImage
                url={image?.path}
                alt={image.text ? image.text : 'Objektbild'}
                text={image?.text ? image?.text : ''}
                key={image?.path}
                index={index}
              />
            );
          })}
    </>
  );
};

export default ImageView;
